import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { initHttpOperation, pollHttpOperation } from "../../http/operation.js";
import { logger } from "../../logger.js";

var createStateProxy = function createStateProxy() {
  return {
    initState: function initState(config) {
      return {
        config: config,
        isStarted: true
      };
    },
    setCanceled: function setCanceled(state) {
      return state.isCancelled = true;
    },
    setError: function setError(state, error) {
      return state.error = error;
    },
    setResult: function setResult(state, result) {
      return state.result = result;
    },
    setRunning: function setRunning(state) {
      return state.isStarted = true;
    },
    setSucceeded: function setSucceeded(state) {
      return state.isCompleted = true;
    },
    setFailed: function setFailed() {
      /** empty body */
    },
    getError: function getError(state) {
      return state.error;
    },
    getResult: function getResult(state) {
      return state.result;
    },
    isCanceled: function isCanceled(state) {
      return !!state.isCancelled;
    },
    isFailed: function isFailed(state) {
      return !!state.error;
    },
    isRunning: function isRunning(state) {
      return !!state.isStarted;
    },
    isSucceeded: function isSucceeded(state) {
      return Boolean(state.isCompleted && !state.isCancelled && !state.error);
    }
  };
};

export var GenericPollOperation = /*#__PURE__*/function () {
  function GenericPollOperation(state, lro, setErrorAsResult, lroResourceLocationConfig, processResult, updateState, isDone) {
    _classCallCheck(this, GenericPollOperation);

    this.state = state;
    this.lro = lro;
    this.setErrorAsResult = setErrorAsResult;
    this.lroResourceLocationConfig = lroResourceLocationConfig;
    this.processResult = processResult;
    this.updateState = updateState;
    this.isDone = isDone;
  }

  _createClass(GenericPollOperation, [{
    key: "setPollerConfig",
    value: function setPollerConfig(pollerConfig) {
      this.pollerConfig = pollerConfig;
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        var _this = this;

        var _a, stateProxy, updateState, isDone;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                stateProxy = createStateProxy();

                if (this.state.isStarted) {
                  _context.next = 8;
                  break;
                }

                _context.t0 = Object;
                _context.t1 = Object.assign({}, this.state);
                _context.next = 6;
                return initHttpOperation({
                  lro: this.lro,
                  stateProxy: stateProxy,
                  resourceLocationConfig: this.lroResourceLocationConfig,
                  processResult: this.processResult,
                  setErrorAsResult: this.setErrorAsResult
                });

              case 6:
                _context.t2 = _context.sent;
                this.state = _context.t0.assign.call(_context.t0, _context.t1, _context.t2);

              case 8:
                updateState = this.updateState;
                isDone = this.isDone;

                if (!(!this.state.isCompleted && this.state.error === undefined)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return pollHttpOperation({
                  lro: this.lro,
                  state: this.state,
                  stateProxy: stateProxy,
                  processResult: this.processResult,
                  updateState: updateState ? function (state, _ref) {
                    var rawResponse = _ref.rawResponse;
                    return updateState(state, rawResponse);
                  } : undefined,
                  isDone: isDone ? function (_ref2, state) {
                    var flatResponse = _ref2.flatResponse;
                    return isDone(flatResponse, state);
                  } : undefined,
                  options: options,
                  setDelay: function setDelay(intervalInMs) {
                    _this.pollerConfig.intervalInMs = intervalInMs;
                  },
                  setErrorAsResult: this.setErrorAsResult
                });

              case 13:
                (_a = options === null || options === void 0 ? void 0 : options.fireProgress) === null || _a === void 0 ? void 0 : _a.call(options, this.state);
                return _context.abrupt("return", this);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function update(_x) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logger.error("`cancelOperation` is deprecated because it wasn't implemented");
                return _context2.abrupt("return", this);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function cancel() {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
    /**
     * Serializes the Poller operation.
     */

  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify({
        state: this.state
      });
    }
  }]);

  return GenericPollOperation;
}();